import { Component,HostListener,Renderer2 } from "@angular/core";
import { Router, UrlSerializer } from "@angular/router";
import { QuizService } from '../../../Service/Quizservice';
import json from "../../../assets/survey.json";
import { Directive, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { SurveyModel } from 'survey-angular';
import * as Survey from "survey-angular";
import CryptoJS from 'crypto-js';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Multerfileupload } from '../Multerfileupload.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { connectableObservableDescriptor } from "rxjs/internal/observable/ConnectableObservable";
declare var gtag: Function;
@Component({
  selector: "StudentQuiz-page",
  templateUrl: "./StudentQuiz.page.html",
  styleUrls: ["./Student.css"],
})
@Directive({
  selector: '[ngInit]'
})
export class StudentQuizPage {
  range;
  gtmId;
  AssignmentForm: FormGroup;
  json;
  Studentroute;
  @Input() username;
  studentid;
  uplodedfiles: any = [];
  filesize;
  filetype;
  filecount;
  dscrptn;
  resoursefiles;
  status;
  instruction;
  @ViewChild(Multerfileupload) child;
  public Editor = ClassicEditor;
  previewdata;
  url;
  @Output('ngInit') initEvent: EventEmitter<any> = new EventEmitter();
   
  private async getConfigData(): Promise<{ gtmId: string, url: string }> {
    const data = await this.getconfigkey().toPromise();
    return {
      gtmId: data['gtmId'],
      url: data['url']
    };
  }
 async ngOnInit() {
    
     // Append the script to the head section of the document
     

    this.getQuizLink();
    ClassicEditor.create(document.getElementById('myDiv')).then(editor => {
      const formControl = document.getElementById('myDiv') as HTMLInputElement;
      const divElement = document.getElementById('demoDiv');

      // Update the form control value when the editor content changes
      editor.model.document.on('change', () => {
        formControl.value = editor.getData();
        formControl.dispatchEvent(new Event('input'));
      });

      // Override the createUploadAdapter method
      editor.plugins.get('FileRepository').createUploadAdapter = function (loader) {
        return {
          upload: function () {
            return loader.file
              .then(file => new Promise((resolve, reject) => {
                const formData = new FormData();
                formData.append('image', file);
                // Replace this URL with your own server endpoint
                const uploadUrl = localStorage.getItem('uploadUrl');

                const xhr = new XMLHttpRequest();
                xhr.open('POST', uploadUrl, true);
                xhr.setRequestHeader('X-CSRF-TOKEN', 'CSRF-Token-Value'); // Set the CSRF token if required
                xhr.setRequestHeader('Authorization', 'Bearer Token'); // Set the authorization header if required

                xhr.onload = function () {
                  if (xhr.status === 200) {
                    const response = JSON.parse(xhr.responseText);

                    // Get the URL of the uploaded image from the response
                    const imageUrl = `assets/Uploads/${file.name}`;
                    
                    // Create a new image element
                    const imgElement = document.createElement('img');
                    imgElement.src = imageUrl;
                    resolve({
                      default: imageUrl
                    });
                  } else {
                    reject('Upload failed');
                  }
                };

                xhr.onerror = function () {
                  reject('Upload failed');
                };

                xhr.send(formData);
              }));
          }
        };
      };
    }).catch(error => {
      console.error(error);
    });
    this.username = sessionStorage.getItem('studname');
    this.studentid = sessionStorage.getItem("sid")
    const configData = await this.getConfigData();
    this.gtmId = configData.gtmId;
    const script = this.renderer.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id='+this.gtmId;
    console.log(script);
    this.renderer.appendChild(document.head, script);
    
let users;
let roles;

if (this.username) {
  users = this.username;
  roles = "Student";
}


const gTagScript = this.renderer.createElement('script');
gTagScript.text = `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date()); 
gtag('config', '`+this.gtmId+`');
`;

// Append the GTM script to the head section of the document
this.renderer.appendChild(document.head, gTagScript);

// Now you can safely use the gtag function
gtag('event', 'user_details', { 'UserName': users, 'UserType': roles });
    document.getElementById("btnGroupDrop1").innerText = this.username;
    this.AssignmentForm = this.formBuilder.group({
      Astitle: ['', Validators.required],
      Lrnresponse: ['', Validators.required],
      Asscore: ['', Validators.required],
      fsize: ['', Validators.required],
      ftype: [''],
      fcount: ['', Validators.required],
      ckedit: ['',Validators.required],
    });
     this.previewdata = JSON.parse(sessionStorage.getItem("editdata"));
    this.previewAssignment(this.previewdata);
    this.AssignmentForm.disable();
    this.AssignmentForm.controls['ckedit'].enable();
    // var maxFileSize = 2 * 1024 * 1024;
    var filesizelimit = 0;
    var alrtcount = 1;
    if(this.filecount != null && this.filecount != undefined)
    {
    this.child.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
      if (this.child.uploader.queue.length > this.previewdata.filecount) {
        if( alrtcount==1){
          alrtcount=0;
          alert("Upload Limit :" + this.previewdata.filecount + " files")
        }
        this.child.uploader.queue[this.child.uploader.queue.length - 1].remove();
        
      }
      else {
        alrtcount = 1;
      filesizelimit = filesizelimit + file.file.size;
      var actualsize = this.formatSize(filesizelimit)
      if (actualsize[1] == this.previewdata.Filesize.split('$')[1]) {
        if (actualsize[0] > this.previewdata.Filesize.split('$')[0]) {

       this.child.uploader.queue[this.child.uploader.queue.length - 1].remove();
          if (alrtcount == 1) {
            alrtcount = 0;
            alert("Upload " + this.previewdata.filecount + " files of " + this.previewdata.Filesize.split('$')[0] + ' ' + this.previewdata.Filesize.split('$')[1])
          }
          filesizelimit = filesizelimit - file.file.size;
          return;
        }
      }
      }
    };
  
    this.child.uploader.clearQueue=(item)=>{
      filesizelimit=0;
      this.child.uploader.queue = [];
        }
      }
    // this.child.uploader.removeFromQueue=(item)=>{
    //     filesizelimit=filesizelimit-item.file.size;
    //     this.child.uploader.item.remove();
    // }
        // Add an onload event to ensure the script is loaded before using gtag
        script.onload = () => {
          //this.initGtag();
        };
        this.renderer.appendChild(document.head, script);
  }

   public checkError = (controlName: string, errorName: string) => {
    return this.AssignmentForm.controls[controlName].hasError(errorName);
  }
  formatSize(bytes) {
    let sizes = ["bytes", "KB", "MB", "GB", "TB"];
    var l = Math.min(sizes.length - 1, Math.log(bytes) / Math.LN2 / 10 | 0);
    return [bytes / Math.pow(1024, l), sizes[l]];
  }
  constructor(private http: HttpClient,private _snackBar: MatSnackBar,private QuizService: QuizService, private router: Router, private formBuilder: FormBuilder,private renderer:Renderer2) {
    this.json = JSON.parse(sessionStorage.getItem("editjson"));

    this.getconfigkey().subscribe(data=>{
      this.url=data['resourseurl'];

  })
    this.range = new FormGroup({
      start: new FormControl(),
      end: new FormControl()
    });
    if (sessionStorage.getItem("studname") == undefined) {
      this.router.navigate(['/' + this.router.url.split('/')[1]])
    }
    setTimeout(() => {
      sessionStorage.setItem("routeurl", router.url)
    }, 500);
  }
  sendData(result) {
    //TODO update with your own behavior
    const surveyModel = new Survey.Model(this.json);
  }
  Saveassignment(){
    if (!this.AssignmentForm.valid) {
      var snackBarRef=this._snackBar.open("Enter required fields", "Ok", {
      });
      snackBarRef.onAction().subscribe(() => {
          document.getElementById("cancelbtn").click();
      });
      return;
    }
    if(this.filecount != null && this.filecount != undefined)
   this.resoursefiles =    this.child.message;
   else
   this.resoursefiles =[];
    var jsonobj  = 
      {
        "studentDescription":this.AssignmentForm.get('ckedit').value,
        "StudentUploads": this.resoursefiles

      };
      var updatejson = {
        quizid: CryptoJS.AES.decrypt(this.studentid.trim(), 'q').toString(CryptoJS.enc.Utf8),
        submittedans: JSON.stringify(jsonobj)        
      }
      this.QuizService.updatestudentsubmitteddata(JSON.stringify(updatejson))
        .subscribe(data => {
            this.status = data['status'];
        });
        sessionStorage.clear();
  }
  logout() {
    sessionStorage.clear();
  }
  public getconfigkey():any{            
    return this.http.get("assets/env.json");            
    }

  iframeurlset(fileitem)
  {
    window.open( this.url+fileitem.filename);
  }
  previewAssignment(obj) {
    if (obj !=null && obj.Filesize != null) {
      this.filesize = obj.Filesize.split('$')[0];
      this.filetype = obj.Filesize.split('$')[1];
      this.filecount = obj.filecount;
    }
    else {
      this.filesize = null;
      this.filetype = null;
      this.filecount = null;
    }
    this.AssignmentForm.patchValue({
      Astitle: obj.AssignmentTitle,
      Lrnresponse: obj.Learningresponse,
      Asscore: obj.Score,
      fsize: this.filesize,
      ftype: this.filetype,
      fcount: this.filecount,
    });

    if(obj.resourcesinfo != null)
    this.uplodedfiles = obj.resourcesinfo;
    
    this.dscrptn = obj.Description;
    this.instruction =obj.Description;
    this.instruction=this.instruction.replace('<table>', '<table border="1">');
    this.instruction=this.instruction.replace('<a', '<a target="_blanck"');
  }
  async getQuizLink() {
    var uploadLink = await this.http.get('assets/env.json');
    uploadLink.subscribe(data => { localStorage.setItem('uploadUrl', data['uploadurl']) });
  }
  reset()
  {
    this.AssignmentForm.controls['ckedit'].reset();
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    console.log("hello");
  window.history.go(1);
  var encryptedval = CryptoJS.AES.encrypt(this.previewdata.id.trim(), 'q').toString();
      this.router.navigate([this.previewdata.code + "/student"], { queryParams: { Asid: encryptedval } })
  }
  
}
